import styled from 'styled-components'
import {
  Div, H4, Button,
} from 'konsys-ui'
import { theme, media } from '../../../../../styles/_variables'

export const FullWidthContainer = styled.div`
  width: 100%;
  min-height: 200px
`

export const Bar = styled(Div)`
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: space-between;
`

export const Content = styled(Div)`
  padding-top: 12px;
  width: fit-content;
  width: -moz-fit-content;
  @media only screen and (max-width: 960px) {
    width: 100%;
  }
`

export const Title = styled(H4)`
  color: ${theme.color.offWhite};
  ${media.mobileXL`
    margin-left: -60px;
  `}
`

export const ButtonBack = styled(Button)`
  ${media.mobileXL`
    margin-left: -20px;
  `}
`

export default FullWidthContainer



// WEBPACK FOOTER //
// ./src/pages/package-page/detail/components/summary-content/styled.js